import { render, staticRenderFns } from "./AdditionalProductsDialog.vue?vue&type=template&id=ba799a5c&"
import script from "./AdditionalProductsDialog.vue?vue&type=script&lang=js&"
export * from "./AdditionalProductsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalProductsDialog.vue?vue&type=style&index=0&id=ba799a5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports